module.exports = __webpack_public_path__ + "static/media/s3.b7739d74.png";